// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArticleTranslate__container-e35e20 {
  display: flex;
  margin: 16px 0px 32px 0px;
  align-items: center;
}

.ArticleTranslate__icon-f9c1cf {
  fill: var(--base-70);
  margin-inline-end: 8px;
}

.ArticleTranslate__label-a10a0d {
  margin-inline-end: 16px;
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
  color: var(--base-80);
}

.ArticleTranslate__button-a963fb {
  cursor: pointer;
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
  color: var(--base-100);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/ArticlePreview/Payloads/components/ArticleTranslate/styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,sBAAA;AACF;;AAEA;EACE,uBAAA;EACA,4BAAA;EACA,8CAAA;EACA,qBAAA;AACF;;AAEA;EACE,eAAA;EACA,4BAAA;EACA,8CAAA;EACA,sBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  margin: 16px 0px 32px 0px;\n  align-items: center;\n}\n\n.icon {\n  fill: var(--base-70);\n  margin-inline-end: 8px;\n}\n\n.label {\n  margin-inline-end: 16px;\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n  color: var(--base-80);\n}\n\n.button {\n  cursor: pointer;\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n  color: var(--base-100);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ArticleTranslate__container-e35e20`,
	"icon": `ArticleTranslate__icon-f9c1cf`,
	"label": `ArticleTranslate__label-a10a0d`,
	"button": `ArticleTranslate__button-a963fb`
};
module.exports = ___CSS_LOADER_EXPORT___;
